import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Api from '@services/contact.service';
import { textareaTextToArrayWithParams } from '@utils/utils';

export const fetch_contact = createAsyncThunk(
  'contact/fetch_contact',
  async (_, thunkAPI) => {
    try {
      const response = await Api.get_contact();
      return response.data;
    } catch {
      return '';
    }
  },
);
export const contactSlice = createSlice({
  name: 'contact',
  initialState: {
    contact: {},
    is_fetching_contact: false,
  },
  reducers: {
    setInfo: (state, action) => {
      state.contact = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetch_contact.fulfilled, (state, action) => {
        let fetchedData = action.payload;
        if (Array.isArray(action.payload)) {
          fetchedData = fetchedData.map((item) => {
            return { id: item.id, slug: item.slug, ...item.acf };
          });
        }

        if (fetchedData.length === 0) {
          state.contact = {};
          state.is_fetching_contact = false;
          return;
        }

        state.contact = fetchedData[0];
        state.is_fetching_contact = false;
      })
      .addCase(fetch_contact.pending, (state) => {
        state.is_fetching_contact = true;
      });
  },
});

export const { setInfo } = contactSlice.actions;

export default contactSlice.reducer;
